export default{
  profiles:[
    {
      id: 0,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '4'
      },
      title: '',
      text: 'Pierwszy Prezes Środowiska Ryszard Andrys-Jankowski',
      img: '/srodowiska/srod_warszawa/ryszard_andrys_jankowski.jpg'
    },
    {
      id: 1,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '4'
      },
      title: '',
      text: 'Zygmunt Ryszard Szwojnicki Drugi Prezes Środowiska',
      img: '/srodowiska/srod_warszawa/zygmunt_ryszard_szwojnicki.jpg'
    },
    {
      id: 2,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '4'
      },
      title: '',
      text: 'Jerzy Gillern Trzeci Prezes Środowiska',
      img: '/srodowiska/srod_warszawa/jerzy_gillern.jpg'
    },
    {
      id: 3,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '4'
      },
      title: '',
      text: 'Tadeusz Siemaszko Czwarty Prezes Środowiska',
      img: '/srodowiska/srod_warszawa/tadeusz_siemaszko.jpg'
    },
    {
      id: 4,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '4'
      },
      title: '',
      text: 'Janusz Bohdanowicz Piąty Prezes Środowiska',
      img: '/srodowiska/srod_warszawa/janusz_bohdanowicz.jpg'
    }
  ],
  lists:{
    konkursy:[
      'Liceum Ogólnokształcące im. Powstańców Warszawskich w Warszawie ul. Zbarska 1 – 02.10.2006 r.',
      'Liceum Ogólnokształcące im. C.K. Norwida w Wyszkowie – 01.03.2007 r.',
      'Liceum Ogólnokształcące Zespół Szkół Nr 3. w Wyszkowie ul. J. Matejki 9 – 20.06.2007 r.',
      'Zespół Szkolenia Ustawicznego w Wyszkowie ul. Matejki 9 – 20.06.2007 r',
      'Gimnazjum Publiczne w Czerniewicach – 10.10.2007 r.',
      'Gimnazjum Publiczne w Żelechlinku – 09.05.2008 r.',
      'Gimnazjum Publiczne w Żelechlinku – 20.02. 2009 r.',
      'Gimnazjum Publiczne w Lubochni – 24.02.2009 r.',
      'Gimnazjum z Oddziałami Dwujęzycznymi Nr 47 im. Marszałka J. Piłsudskiego w Warszawie, ul. Grenady nr 16 – 16.03.2009 r. rozdanie nagród 23.03.2009 r.',
      'Gimnazjum nr 86 im. Ignacego Augusta Boernera Warszawie ul. Thommeego 1 – 16.03.2009 r. i 23.03.2009 r.',
      'Gimnazjum nr 50 im. gen. W. Sikorskiego w Warszawie, ul. J. Bema 76 –16.03.2009 r. i 23.03.2009 r.',
      'Gimnazjum nr 6 im. Pułku Armii Krajowej Baszta, w Warszawie ul. Gruszczyńskiego 12 – 16.03.2009 r. i 23.03. 2009 r.',
      'Publiczne Gimnazjum w Lubochni – 26.03.2010 r.',
      'Publiczne Gimnazjum w Żelechlinku – 26.03.2010 r.',
      'Publiczne Gimnazjum w Rzeczycy – 26.03.2010 r.',
      'Gimnazjum Nr 3 w Tomaszowie Mazowieckim – 26.03.2010 r.',
      'Gimnazjum z Oddziałami Dwujęzycznymi Nr 47 im. Marszałka J. Piłsudskiego w Warszawie, ul. Grenady 16 - 29.03.2010 r. i 09.04.2010 r.',
      'Gimnazjum nr 50 im. gen. W. Sikorskiego w Warszawie, ul. J. Bema 76 –29.03.2010 r. i 09.04.2010 r.',
      'Gimnazjum nr 45 im. Powstania Warszawskiego w Warszawie, ul. Żelazna 71 –29.03.2010 r. i 09. 04. 2010 r.',
      'Gimnazjum nr 86 im. Ignacego Augusta Bernera w Warszawie, ul. Thommeego – 29.03.2010r. i 09.04.10 r.'
    ],
    sympozja:[
      {
        id: 0,
        text: 'Liceum Ogólnokształcące nr 2 w Lęborku. Nauczyciel historii mgr Bogusława Zielińska.',
        list:[
          'Armia Krajowa Okręg Wileński'
        ]
      },
      {
        id: 1,
        text: 'Liceum Ogólnokształcące Nr 1 w Lęborku. Nauczyciel historii Bogdan Lipich.',
        list:[
          'Polskie Państwo Podziemne'
        ]
      },
      {
        id: 2,
        text: 'Gimnazjum Nr 2 im. Armii Krajowej w Kwidzynie. Nauczyciel historii mgr Beata Kamińska.',
        list:[
          'Cichociemni',
          'Represje wobec Armii Krajowej w powojennej Polsce',
          'Pamiętnik powstańca',
          'Armia Krajowa dawniej, a dziś'
        ]
      },
      {
        id: 3,
        text: 'Zespół Szkół Ponadgimnazjalnych im. Ignacego Łukaszewicza w Krośnie. Nauczyciel historii mgr Krzysztof Zajka.',
        list:[
          'Armia Krajowa Podokręg Rzeszów'
        ]
      },
      {
        id: 4,
        text: 'Gimnazjum Samorządowe im. Jana Pawła II w Bolszewie. Nauczyciel historii mgr Aleksandra Hirsch.',
        list:[
          'Okręg Wileński AK Inspektorat „F”',
          'Represje sowieckie Okręgu Wileńskiego AK',
          'Polskie Państwo Podziemne',
          'Organizacja i działalność niepodległościowa ZWZ i AK Okręg Wileński',
          'Służby Sanitarne Cywilne i Armii Krajowej'
        ]
      },
      {
        id: 5,
        text: 'Zespół Szkół Ponadgimnazjalnych nr 4 im. Jakuba Wejhera w Wejherowie. Nauczyciel historii mgr Sebastian Cieślikowski.',
        list:[
          'Działalność POW „ Gryf Pomorski” w okresie II Wojny Światowej',
          'Działalność polskich organizacji niepodległościowych na Pomorzu'
        ]
      }
    ],
    prelekcje_materialy_biblioteki:[
      {
        id: 0,
        title: 'Prelekcje w tym samym okresie (Łącznie zorganizowano i przeprowadzono 7 prelekcji.)',
        list:[
          'Prelekcja o Armii Krajowej Okręgu Wileńskiego w Gimnazjum nr 47 im. J. Piłsudskiego w Warszawie – Janusz Bohdanowicz.',
          'Dwie prelekcje w Gimnazjum nr 50 im. gen. Sikorskiego w Warszawie o PPP, SZP i AK Okręgu Wileńskiego – Romuald Paprocki i Janusz Bohdanowicz.',
          'Dwie prelekcje w Domu Spotkań z Historią w Warszawie przy ul. Karowej o działalności niepodległościowej w okresie 1939-1941 i o okresie 1941-1945 – Romuald Paprocki i Janusz Bohdanowicz.',
          'Prelekcja w V Liceum Ogólnokształcącym im. Ks. Józefa Poniatowskiego w Warszawie o Armii Krajowej Okręgu Wileńskiego- Janusz Bohdanowicz.',
          'Prelekcja w Gimnazjum Publicznym im. Aliny Janusz w Starych Załubicach o działalności niepodległościowej Okręgu Wileńskiego w okresie 1939-1945 – Romuald Paprocki i Janusz Bohdanowicz.'
        ]
      },
      {
        id: 1,
        title: 'Przekazane materiały historyczne do bibliotek wytypowanych Gimnazjów.',
        list:[
          'Gimnazjum nr 47 im. Józefa Piłsudskiego w Warszawie.',
          'Samorządowe Gimnazjum im. Jana Pawła II w Bolszewie.',
          'Publiczne Gimnazjum im. Ofiar Katynia w Piątnicy',
          'Publiczne Gimnazjum w Lubochni.',
          'Publiczne Gimnazjum w Żelechlinku.',
          'Zespół Szkół Ponadgimnazjalnych nr 3 w Zamościu.',
          'Gimnazjum Publiczne w Starych Załubicach.'
        ]
      },
      {
        id: 2,
        title: 'Do bibliotek w/w szkół w okresie sprawozdawczym nie odpłatnie przekazano.',
        list:[
          'Zeszytów z materiałami historycznymi - egz. 316',
          'Nagrań elektronicznych na płytach - egz. 152',
          'Książki historyczne - egz. 72',
          'Przekaz Wileński - egz. 10',
          'Pamiętnik Okręgu Wileńskiego - egz. 37',
          'Rozmaitości Wileńskie - egz. 91'
        ]
      }
    ],
    zarzad_wykaz:[
      {
        id: 0,
        title: 'Zarząd Środowiska w roku 2011 i do czerwca 2012 roku przekazał nieodpłatnie (Ponadto w Gimnazjum nr 3 im. Marszałka Józefa Piłsudskiego w Warszawie odbyła się prelekcja dla uczniów klas 2-ich i 3-ich. Prelekcji wysłuchało 62 uczniów.)',
        list:[
          'W Wilnie nauczycielom szkół polskich i działaczom AWPL i Związkowi Polaków na Litwie - 28 nagrań elektronicznych materiałów historycznych, 19 książek historycznych i 50 zeszytów historycznych.',
          'Członkom Klubu Weteranów Armii Krajowej na Litwie - 50 nagrań elektronicznych materiałów historycznych.',
          'Dla Domu Kultury Polskiej w Wilnie - 49 książek o tematyce historycznej Armii Krajowej',
          'Dla władz rejonu Wileńskiego i Solecznickiego, nauczycieli szkół polskich tych rejonów i przedstawicielom Rzeczypospolitej na Litwie oraz działaczom mieszkającym na Litwie - 274 nagrań elektronicznych materiałów historycznych dotyczących Okręgu Wileńskiego Armii Krajowej.',
          'Bibliotece Gimnazjum nr 3 im. Marszałka Józefa Piłsudskiego w Warszawie - 69 książek o historii Armii Krajowej.',
          'Koledze Longinowi Tomaszewskiemu w Warszawie - 26 nagrań elektronicznych o Armii Krajowej.',
          'Do ryngrafów brygadowych dołączono i przekazano partyzantom lub ich rodzinom - 368 nagrań elektronicznych dotyczących ich Brygad.'
        ]
      },
      {
        id: 1,
        title: 'Wykaz tematów proponowanych przez Okręg Woleński',
        list:[
          'Organizacja i działalność niepodległościowa SZP i ZWZ Okręgu Wileńskiego od września 1939 do czerwca 1941 r.',
          'Organizacja i działalność niepodległościowa ZWZ i AK Okręgu Wileńskiego od czerwca 1941 do czerwca 1945 r.',
          'Represje sowieckie obywateli polskich za działalność niepodległościową Okręgu Wileńskiego.',
          'Inspektorat „A” – Zgrupowanie Nr. 1 i Garnizon m. Wilno majora „Pohoreckiego” lub jego jednostki',
          'Inspektorat „BC” – Zgrupowanie Nr. 2 Majora „Węgielnego”lub jego jednostki',
          'Inspektorat „F” – Zgrupowanie Nr. 3 Majora „Jaremy” lub jego jednostki',
          'Legalizacja.',
          'Polskie Państwo Podziemne. Władze administracji cywilnej.',
          'Służby sanitarne. Cywilne i Armii Krajowej.'
        ]
      }
    ]
  },
  videos:[
    {
      id: 0,
      text: 'Finał konkursu historycznego w gimnazjum w Lubochni 24 lutego 2009r. (fragment)',
      url: "https://www.youtube.com/embed/C4xKhAD8HKE"
    },
    {
      id: 1,
      text: 'Finały konkursów historycznych w gimnazjum w Żelechlinku w latach 2008 i 2009 (fragment)',
      url: "https://www.youtube.com/embed/VBoXZrqJlH4"
    },
    {
      id: 2,
      text: 'Finał konkursu historycznego z udziałem 10 drużyn z pięciu gimnazjów z Warszawy (fragment)',
      url: "https://www.youtube.com/embed/NLc0-i5TVfE"
    }
  ],
  carousel:[
    {
      id: 0,
      title: '',
      text: '6 Brygada "Tonki" i "Konara"',
      img: "/srodowiska/srod_warszawa/6_Brygada.jpg"
    },
    {
      id: 1,
      title: '',
      text: '3 Brygada "Szczerbca"',
      img: "/srodowiska/srod_warszawa/3_Brygada.jpg"
    },
    {
      id: 2,
      title: '',
      text: '7 Brygada "Wilhelma"',
      img: "/srodowiska/srod_warszawa/7_Brygada.jpg"
    },
    {
      id: 3,
      title: '',
      text: 'Ryngraf 13 Brygady "Nietoperza"',
      img: "/srodowiska/srod_warszawa/13_Brygady.jpg"
    },
    {
      id: 4,
      title: '',
      text: '1 Brygada Juranda',
      img: "/srodowiska/srod_warszawa/1_Brygada.jpg"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/srodowiska/srod_warszawa.js